export const STATUS_ACTION = {
  PAUSED: 'PAUSED',
  CLOSED: 'CLOSED',
  NONE: 'NONE'
};

const PAUSED_STATUS = 'BLOCKED';
const CLOSED_STATUSES = [
  'NEED GRADING',
  'AWAITING VALIDATION',
  'APROVED',
  'REPROVED'
];

export const STATUS_NOTICE_MESSAGES = {
  [STATUS_ACTION.PAUSED]: 'Sua avaliação foi suspensa temporariamente',
  [STATUS_ACTION.CLOSED]: 'Sua tentativa foi encerrada pelo aplicador'
};

export function resolveVestibularStatusAction(status) {
  if (status === PAUSED_STATUS) {
    return STATUS_ACTION.PAUSED;
  }
  if (CLOSED_STATUSES.includes(status)) {
    return STATUS_ACTION.CLOSED;
  }
  return STATUS_ACTION.NONE;
}

export function resolvePollingAction(status, hasOwnSubmission) {
  const action = resolveVestibularStatusAction(status);
  if (action === STATUS_ACTION.CLOSED && hasOwnSubmission) {
    return STATUS_ACTION.NONE;
  }
  return action;
}
